import { CARRIERS_BY_INSURANCE_TYPE_STATE_KEY } from './carriersConstants';
import { createSelector } from 'reselect';
import insuranceSelector from '../insuranceSelector';

const carriersByInsuranceTypeSelector = createSelector(
    insuranceSelector,
    insurance => insurance[CARRIERS_BY_INSURANCE_TYPE_STATE_KEY]
);

export default carriersByInsuranceTypeSelector;
